export default {
  quests_pending: false,
  quests: []
}
